module.exports = __webpack_public_path__ + "static/desktop-apply-102cce1b4b486259f46cea2c33818879.png";